export function formatApiError(error: any, fallbackMessage: string = 'Erro desconhecido'): string {
  if (error?.error?.errors) {
    return Object.entries(error.error.errors)
      .map(([field, msgs]) => `${field}: ${(msgs as string[]).join(', ')}`)
      .join('\n');
  } else if (error?.error?.detail) {
    return error.error.detail;
  } else if (error?.error?.Data?.ErrorMessage) {
    return error.error.Data.ErrorMessage;
  }
  return fallbackMessage;
}